// A way back to Admin Home from the field pages an admin opens to preview (Quiz 1 to 3, the
// Guest Page). Robert, iPad test 2026-10-15: in the Home Screen app there is no browser Back,
// so Quiz 1 opened from Admin Home was a dead end.
//
// Admin Home adds from=admin to those links. The field page then shows one thin bar above
// itself: "‹ Admin Home". A trainee or a guest who scans a label never sees it.
// The bar sits outside #app, so a field page redrawing itself never removes it.

const PARAM = "from";
const VALUE = "admin";

/** Adds from=admin to a field page link ("/?quiz=1"). Links into the admin app are left alone. */
export function withAdminBack(href: string): string {
  if (!href.startsWith("/?")) return href;
  const [path, hash = ""] = href.split("#");
  const sep = path!.includes("?") ? "&" : "?";
  return `${path}${sep}${PARAM}=${VALUE}${hash ? `#${hash}` : ""}`;
}

/**
 * A link from one field page to another keeps the bar when this page has it (NAV_AUDIT.md item 9).
 * Scan Again, Open This Tag and the way back to the Guest Page used to drop it, so the admin lost his way home.
 */
export function keepAdminBack(href: string, search: string): string {
  return cameFromAdmin(search) ? withAdminBack(href) : href;
}

/** True when the page was opened from Admin Home. */
export function cameFromAdmin(search: string): boolean {
  return new URLSearchParams(search).get(PARAM) === VALUE;
}

export function adminWayBackHtml(): string {
  return '<nav class="way-back" id="way-back"><a href="/">‹ Admin Home</a></nav>';
}

/** Puts the bar above #app once. Safe to call again. */
export function mountAdminWayBack(doc: Document): void {
  if (doc.getElementById("way-back")) return;
  const app = doc.getElementById("app");
  app?.insertAdjacentHTML("beforebegin", adminWayBackHtml());
}
